__webpack_require__.p = "/aWordaGami/";